module.exports = __webpack_public_path__ + "static/media/quiz-checkmark-light-off@2x.811fc8af.png";